module.exports = __webpack_public_path__ + "static/media/retos_segumiento.67f63073.png";